var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('img',{attrs:{"src":_vm.pageBackground,"id":"PageBackground","alt":""}}),_c('h1',{staticClass:"font-weight-light",attrs:{"id":"text"}},[_vm._v(_vm._s(_vm.pageTitleName))])])
}
var staticRenderFns = []

export { render, staticRenderFns }